import React, { createContext, useContext } from 'react';

const ThemeContext = createContext('light');

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ theme, children }) => (
    <ThemeContext.Provider value={theme}>
        {children}
    </ThemeContext.Provider>
);
